import { axios } from '@lib/axios';

import {
    EntryTranslationData,
    EntryTranslationParams,
    EntryTranslationsParams,
    EntryTranslationResponse,
    EntryTranslationStatusParams,
    EntryTranslationStatusUpdateForm,
    EntryTranslationUpdateForm,
    EntryTranslationsUpdateForm,
} from 'chaika-frontend-types/frontend-cms';
import { Locale } from 'chaika-enums';

const BASE_URL = '/api/entry';

export class EntryTranslationApi {
    public static async getEntryTranslations(id: string): Promise<EntryTranslationData[]> {
        const res = await axios.get<EntryTranslationResponse>(`${BASE_URL}/${id}/translation`, {
            skipForbiddenPopup: true,
        });

        return res.data.translations;
    }

    public static async updateEntryTranslationField(
        id: string,
        locale: Locale,
        translation: EntryTranslationParams,
    ): Promise<void> {
        await axios.put<EntryTranslationUpdateForm>(`${BASE_URL}/${id}/translation/${locale}`, { translation });
    }

    public static async updateEntryTranslationFields(
        id: string,
        locale: Locale,
        translation: EntryTranslationsParams,
    ): Promise<void> {
        await axios.put<EntryTranslationsUpdateForm>(`${BASE_URL}/${id}/translations/${locale}`, { translation });
    }

    public static async updateEntryTranslationStatus(
        id: string,
        locale: Locale,
        translation: EntryTranslationStatusParams,
    ): Promise<void> {
        await axios.put<EntryTranslationStatusUpdateForm>(`${BASE_URL}/${id}/translation/${locale}/status`, {
            translation,
        });
    }
}
